import { withInstall } from '@jdesign-vue/utils'

import Scrollbar from './src/scrollbar.vue'

export const JdScrollbar = withInstall(Scrollbar)
export default JdScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
